import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private toastController: ToastController) {}
  async alert(msg: string) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2500,
      position: 'top',
    });

    await toast.present();
  }
}
